import axios from 'axios';

let token = document.head.querySelector('meta[name="csrf-token"]') || {};

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const axiosReject = function(error) {
    $('body').removeClass('loading');
    if(error.response.data && error.response.data.hasOwnProperty('token')) {
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = error.response.data.token;
        $('meta[name="csrf-token"]').attr('content', error.response.data.token);
    }
    return Promise.reject(error);
};
axios.interceptors.request.use(function(config) {
    const noLoader = config?.data?.noLoader;
    if(typeof noLoader === 'undefined' || !noLoader) {
        $('body').addClass('loading');
    }
    return config;
}, axiosReject);
axios.interceptors.response.use(function(response) {
    $('body').removeClass('loading');
    return response;
}, axiosReject);
if(token.content) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}
else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.axios = axios;
